import { FC } from 'react'

import { ISvgClass } from '../interface'

const CheckIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M10 16.4L6 12.4L7.4 11L10 13.6L16.6 7L18 8.4L10 16.4Z"
        fill="inherit"
      />
    </svg>
  )
}

export default CheckIcon
